import { render, staticRenderFns } from "./UnsolicitedCalleeCheck.vue?vue&type=template&id=c2e96518&scoped=true&"
import script from "./UnsolicitedCalleeCheck.vue?vue&type=script&lang=js&"
export * from "./UnsolicitedCalleeCheck.vue?vue&type=script&lang=js&"
import style0 from "./UnsolicitedCalleeCheck.vue?vue&type=style&index=0&id=c2e96518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e96518",
  null
  
)

export default component.exports